import React from 'react';
import { createPrivateMoney } from '~/javascripts/admin/actions/private-moneys';
import { getUserInfo } from '~/javascripts/admin/actions/user';
import { useAppDispatch } from '~/javascripts/admin/hooks/useApp';
import Headings from '../../atoms/Headings';
import BreadCrumb from '../../molecules/BreadCrumb';
import EditPrivateMoney, { PrivateMoneyFormValues } from '../EditPrivateMoney';

const CRUMBS = [
  { value: 'ホーム', href: '/', isCurrentPage: false },
  { value: 'サービス管理', href: '', isCurrentPage: true },
  { value: 'マネー登録', href: '', isCurrentPage: true },
];

const CreatePrivateMoney = () => {
  const dispatch = useAppDispatch();

  const onConfirm = async (formValues: PrivateMoneyFormValues) => {
    const {
      expires_in,
      point_expires_in,
      total_topup_limit,
      square_small_image,
      card_image,
      payment_sound,
      can_use_seven_bank_atm,
      seven_bank_issuer_code,
      seven_bank_issuer_name,
      seven_bank_money_name,
      topup_method_amounts_for_seven_bank_atm,
      can_use_bank_pay,
      bank_pay_p_id,
      bank_pay_iss_type,
      bank_pay_store_code,
      bank_pay_bankbook_merchant_name,
      use_webhook_callback_url,
      transaction_webhook_callback_url,
      use_itrust_tenent,
      itrust_tenant_code,
      resident_address_pattern,
      identification_validity_days,
      use_fallback_payment,
      fallback_private_money_uuid,
      ...rest
    } = formValues;

    // string of 'null' will be set in form data but null keyword will be removed
    const transformedValues = {
      ...rest,
      expires_in_months: expires_in.unit === 'months' ? expires_in.amount : 'null',
      expires_in_days: expires_in.unit === 'days' ? expires_in.amount : 'null',
      point_expires_in_months:
        point_expires_in.unit === 'months' ? point_expires_in.amount : 'null',
      point_expires_in_days: point_expires_in.unit === 'days' ? point_expires_in.amount : 'null',
      total_topup_limit_type: total_topup_limit.type ?? 'null',
      total_topup_limit_amount: total_topup_limit.amount ?? 'null',
      total_topup_limit_started_at:
        total_topup_limit.type !== 'range' ? 'null' : total_topup_limit.started_at,
      square_small_image: square_small_image.file,
      card_image: card_image.file,
      payment_sound: payment_sound.file,
      bank_pay_p_id: can_use_bank_pay ? bank_pay_p_id : null,
      bank_pay_iss_type: can_use_bank_pay ? `ISS${bank_pay_iss_type}` : null,
      bank_pay_store_code: can_use_bank_pay ? bank_pay_store_code : null,
      bank_pay_bankbook_merchant_name: can_use_bank_pay ? bank_pay_bankbook_merchant_name : null,
      seven_bank_issuer_code: can_use_seven_bank_atm ? seven_bank_issuer_code : null,
      seven_bank_issuer_name: can_use_seven_bank_atm ? seven_bank_issuer_name : null,
      seven_bank_money_name: can_use_seven_bank_atm ? seven_bank_money_name : null,
      topup_method_amounts_for_seven_bank_atm: can_use_seven_bank_atm
        ? topup_method_amounts_for_seven_bank_atm
        : null,
      transaction_webhook_callback_url: use_webhook_callback_url
        ? transaction_webhook_callback_url
        : null,
      itrust_tenant_code: use_itrust_tenent ? itrust_tenant_code : null,
      resident_address_pattern: use_itrust_tenent ? resident_address_pattern : null,
      identification_validity_days: use_itrust_tenent ? identification_validity_days : null,
      fallback_private_money_uuid: use_fallback_payment ? fallback_private_money_uuid : null,
    };

    const formData = new FormData();
    formData.append('_csrf_token', window._csrf_token);
    Object.keys(transformedValues).forEach((key) => {
      if (transformedValues[key] != null) {
        formData.append(key, transformedValues[key]);
      }
    });

    await dispatch(createPrivateMoney(formData)).then(() => dispatch(getUserInfo()));
  };

  return (
    <>
      <BreadCrumb crumbs={CRUMBS} />
      <Headings.h5>マネー登録</Headings.h5>
      <EditPrivateMoney mode="create" onConfirm={onConfirm} />
    </>
  );
};

export default CreatePrivateMoney;
